import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertaService } from '@/Servicios';

@Component({ selector: 'alerta', templateUrl: 'alerta.component.html' })

export class AlertaComponent implements OnInit, OnDestroy {
    private subscription: Subscription;
    message: any;

    constructor(private alertService: AlertaService) { }

    ngOnInit() {
        this.subscription = this.alertService.getAlert()
            .subscribe(message => {
                switch (message && message.type) {
                    case 'success':
                        message.cssClass = 'alert alert-success';
                        break;
                    case 'error':
                        message.cssClass = 'alert alert-danger';
                        break;
                    case 'info':
                        message.cssClass = 'alert alert-info';
                        break;
                    case 'primary':
                        message.cssClass = 'alert alert-primary';
                        break;
                    case 'warning':
                        message.cssClass = 'alert alert-warning';
                        break;
                    case 'secondary':
                        message.cssClass = 'alert alert-secondary';
                }
                this.message = message;
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}